module.exports = __webpack_public_path__ + "img/list07.b9a2197d.jpg";